import { useEffect, useState } from "react";
import PortalLayout from "@/layouts/PortalLayout";
import { api } from "@/lib/api";
import { Trophy, TrendingUp, Lightbulb, CheckCircle2, Lock } from "lucide-react";
import { useLang } from "@/context/LangContext";

export function MyScoreBody() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/portal/my-score").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div>
        <h2 className="text-2xl font-bold text-navy"><Trophy className="mr-2 inline h-6 w-6 text-amber-500" />{t("portal_myscore_01")}</h2>
        <p className="mt-1 text-sm text-neutral-600">{t("portal_myscore_02")}</p>
      </div>

      {!data && <div className="mt-12 text-center text-neutral-500">{t("portal_myscore_90")}</div>}

      {data && (
        <>
          <div className="mt-6 overflow-hidden rounded-3xl border border-amber-200 bg-gradient-to-br from-amber-50 via-wine-50 to-white p-6 shadow-sm">
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <div className="text-xs font-bold uppercase tracking-wider text-amber-700">Score total</div>
                <div className="mt-1 font-serif text-6xl font-bold text-wine-700" data-testid="score-total">{data.total} <span className="text-2xl text-neutral-500">pts</span></div>
              </div>
              <div className="rounded-full bg-white/80 px-4 py-2 text-xs font-semibold text-wine-700"><TrendingUp className="mr-1 inline h-3.5 w-3.5" />{t("portal_myscore_03")}</div>
            </div>
          </div>

          <h3 className="mt-8 text-lg font-bold text-navy">{t("portal_myscore_04")}</h3>
          <p className="mt-1 text-xs text-neutral-500">Détail de votre score : pour chaque type d&apos;action, vous voyez combien vous en avez réalisé, combien de points elles rapportent, et le total que vous avez obtenu.</p>
          <div className="mt-4 space-y-3">
            {Object.values(data.breakdown).map((b) => {
              const earned = b.count > 0;
              return (
              <div key={b.key || b._id} className={`flex items-center gap-4 rounded-2xl border bg-white p-4 ${earned ? "border-emerald-200" : "border-neutral-100"}`} data-testid={`score-rule-${b.key || b._id}`}>
                <div className={`grid h-12 w-12 shrink-0 place-items-center rounded-xl ${earned ? "bg-emerald-50 text-emerald-700" : "bg-neutral-100 text-neutral-400"}`}>
                  {earned ? <CheckCircle2 className="h-5 w-5" /> : <Lock className="h-5 w-5" />}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="font-bold text-neutral-900">{b.label}</div>
                    <div className="font-serif text-2xl font-bold text-wine-700" data-testid={`score-subtotal-${b.key || b._id}`}>{b.subtotal}<span className="ml-1 text-xs font-semibold text-neutral-500">pts obtenus</span></div>
                  </div>
                  <div className="text-xs text-neutral-600">{b.description}</div>
                  <div className="mt-2 inline-flex flex-wrap items-center gap-1.5 rounded-lg bg-neutral-50 px-2.5 py-1 text-[11px] text-neutral-700">
                    <span className="font-bold text-neutral-900">{b.count}</span>
                    <span>action{b.count > 1 ? "s" : ""} réalisée{b.count > 1 ? "s" : ""}</span>
                    <span className="text-neutral-400">×</span>
                    <span className="font-bold text-neutral-900">{b.points}</span>
                    <span>pt{b.points > 1 ? "s" : ""} / action</span>
                    <span className="text-neutral-400">=</span>
                    <span className="font-bold text-wine-700">{b.subtotal} pts</span>
                  </div>
                </div>
              </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-2xl border border-amber-200 bg-amber-50/50 p-5" data-testid="score-tips">
            <h3 className="text-sm font-bold text-amber-800"><Lightbulb className="mr-1 inline h-4 w-4" />Comment progresser ?</h3>
            <ul className="mt-2 list-disc space-y-1 pl-5 text-xs text-amber-900">
              <li>{t("portal_myscore_05")}</li>
              <li>{t("portal_myscore_06")}</li>
              <li>{t("portal_myscore_07")}</li>
              <li>{t("portal_myscore_08")}</li>
              <li>{t("portal_myscore_09")}</li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

export default function MyScore() {
  return (
    <PortalLayout sidebar="member">
      <MyScoreBody />
    </PortalLayout>
  );
}
